/* istanbul ignore next */
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import Cart_Error from 'styles/staticAssets/images/Cart_Error.svg';

import { isEmptyEvery, getTernaryValue, getAndCheck } from 'common/utilities/utils';
import MenuSubCategoryItemList from '../Presentation/MenuSubCategoryItemList';
import MenuItemList from '../Presentation/MenuItemList';
import { isEmpty } from 'lodash';

import {
  BACK_TO_MENU,
  CATEGORY_ID,
  MENU_PLP_CONSTANT,
  TURNED_NO_RESULTS_TEXT,
  YOUR_SEARCH_TEXT,
  SORRY_THIS_FOOD,
  IS,
  FOR,
  NOT_AVAILABLE
} from '../MenuPLPConstants/MenuPLPConstants';
import { ButtonComp } from 'atoms/Buttons';
import { Link } from 'react-scroll';

const {
  CARD_TYPE: { CAROUSAL, MEDIUM },
} = MENU_PLP_CONSTANT;

const hasSubcategory = (subcategory = []) => {
  return subcategory.length > 0;
};

const getMenusSubcategory = (category, handleSetActive, onItemClick) => {
  return (
    !isEmpty(category) &&
    category.map(({ id = '', isHidden = false, dname = '', url, categories: subcategory = [] }, index) => {
      return (
        <ul className='inner-ul nested'>
          {!isHidden && (
            <li>
              <Link
                data-testid='subcategory-click-test'
                className={`${hasSubcategory(subcategory) ? 'caret' : ''}`}
                onClick={e => onItemClick(e, dname[0]?.value, url, index)}
                to={id}
                spy={true}
                smooth={true}
                onSetActive={handleSetActive}
                activeClass={`${index === 0 ? 'active' : ''}`}
              >
                {dname[0]?.value}
              </Link>
              {subcategory && subcategory.length > 0 && getMenusSubcategory(subcategory)}
            </li>
          )}
        </ul>
      );
    })
  );
};

/* incorrect url for deeplink Modal close on click */
const handleClose = (setCategoryStatus, history) => {
  setCategoryStatus(false);
  history.push({
    pathname: '/menu',
  });
};

/* Modal for error message when incorrect url for deeplink */
const displaySectionWhenThereAreNoMatchingProduct = (
  paramValue,
  dispositionNew,
  dispositionType,
  categoryStatus,
  storeClosedData,
  // handleClose,
  setCategoryStatus,
  history,
) => {
  const PRODUCT_NOT_FOUND_CONSTANTS = {
    CLEAR_ALL_MSG: {
      MSGTXT1: `${translateWithI18Next(SORRY_THIS_FOOD)} ${translateWithI18Next(paramValue)} ${translateWithI18Next(IS)} `,
      MSGTXT2: translateWithI18Next(NOT_AVAILABLE),
      MSGTXT3: getTernaryValue(dispositionNew?.type, `${translateWithI18Next(FOR)} ${translateWithI18Next(dispositionType)}`, ''), // exploring our menu option.',
    },
    CONTINUE: 'continue',
  };

  return (
    /* Modal for error message when incorrect url for deeplink */
    getAndCheck(categoryStatus, !storeClosedData?.isStoreClosed) && (
      <CartAlertFormInsideModel
        handleClose={() => handleClose(setCategoryStatus, history)}
        classNames='clear-cart-modal'
        CartAlertForm={
          <CartAlertForm
            splitTitle={PRODUCT_NOT_FOUND_CONSTANTS.CLEAR_ALL_MSG}
            imageSrc={Cart_Error}
            altText={'cart-error'}
            confirmButtonText={translateWithI18Next(PRODUCT_NOT_FOUND_CONSTANTS?.CONTINUE)}
            confirmHandler={() => handleClose(setCategoryStatus, history)}
          />
        }
      />
    )
  );
};

const getDispositionNewData = userOrderState => {
  return isEmptyEvery(userOrderState?.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState?.dispositionNew;
};

/* show products for desktop and mobile view */
const renderItemList = (
  productsList,
  cardId,
  cType,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  subCategories,
) => {
  return subCategories?.length ? (
    <MenuSubCategoryItemList
      subCategory={subCategories}
      cardType={cType}
      tenantData={tenantData}
      catalogs={catalogs}
      storeClosedData={storeClosedData}
    />
  ) : (
    <MenuItemList
      productList={productsList}
      cardType={cType}
      tenantData={tenantData}
      categoryId={cardId}
      catalogs={catalogs}
      selectedCat={selectedCat}
      storeClosedData={storeClosedData}
      cardCount={getCardCount}
    />
  );
};

// menu search functionality result view

const renderMenuList = (
  recommendProducts,
  tenantData,
  catalogs,
  storeClosedData,
  getCardCount,
  cardType,
  categoryId,
) => {
  return (
    <MenuItemList
      productList={recommendProducts}
      cardType={cardType}
      tenantData={tenantData}
      categoryId={categoryId}
      catalogs={catalogs}
      storeClosedData={storeClosedData}
      cardCount={getCardCount}
    />
  );
};

const searchModeElmnt = (
  searchMode,
  clearSearch,
  recommendProducts,
  tenantData,
  catalogs,
  storeClosedData,
  cardType,
  categoryId,
  carouselCount,
  getCardCount,
  isMobileView = false,
) => {
  return (
    <>
      <div className={!isMobileView ? 'no-search-found-plp' : 'no-mob-search-found-plp'}>
        <span>{translateWithI18Next(YOUR_SEARCH_TEXT)}</span>
        <span className='no-search-found-text-highlighted'>{` “${searchMode.searchedData}” `}</span>
        <p>{translateWithI18Next(TURNED_NO_RESULTS_TEXT)}</p>
        <ButtonComp className='back-to-menu-plpsearch' data-testid='back-to-menu' onClick={clearSearch}>
          {translateWithI18Next(BACK_TO_MENU)}
        </ButtonComp>
      </div>
      <div className='horizontalLineBorder-noData'></div>
      {!!recommendProducts?.length &&
        (!isMobileView ? (
          <div className='mob-plp-sections  mb-5'>
            <div className='mob-plp-col mb-4'>
              <div className='recommended-menu-container recommended-menu-container-sopac medium-menu-container'>
                <div className='d-flex position-relative'>
                  <div className='carousal-header'>{translateWithI18Next(MENU_PLP_CONSTANT.CAROUSAL_HEADER)}</div>
                </div>
                {renderMenuList(recommendProducts, tenantData, catalogs, storeClosedData, '', MEDIUM, CATEGORY_ID)}
              </div>
            </div>
          </div>
        ) : (
          <div className='carousal-menu-container'>
            <div className='d-flex position-relative'>
              <div className='carousal-header'>{translateWithI18Next(MENU_PLP_CONSTANT.CAROUSAL_HEADER)}</div>
              <div className='card-counter'>
                {carouselCount}/{recommendProducts.length}
              </div>
            </div>
            {renderMenuList(
              recommendProducts,
              tenantData,
              catalogs,
              storeClosedData,
              getCardCount,
              CAROUSAL,
              CATEGORY_ID,
            )}
          </div>
        ))}
      <div className='horizontalLineBorder-noData-forMobile'></div>
    </>
  );
};

export {
  hasSubcategory,
  getMenusSubcategory,
  displaySectionWhenThereAreNoMatchingProduct,
  getDispositionNewData,
  renderItemList,
  searchModeElmnt,
};
